import React, { useState } from "react";
import MuiCheckbox from "./checkbox/MuiCheckbox";
import "../components/checkbox/muiCheckbox.scss";
import InputTextField from "./textField/InputTextField";

const neutralLabel = [
  {
    displayName: "Use RevoFit®",
  },
];
const selectedLabel = [
  {
    displayName: "RevoFit®",
  },
];

const Revofit = ({
  setActiveInnerStep,
  labelOnChange,
  checkBoxesOption,
  value,
  revoChange,
  revoFitDefaultValue,
  revoOptionDefaultValue,
  additionalWindowValue,
  additionalWindowRequired,
  additionalWindowChange,
}) => {
  const [showRevo, setShowRevo] = useState(revoFitDefaultValue);

  const additionalWindowId = 160;
  const baseRevoOptionId = 158;
  const revoAdditionIds = [159, 160];
  const lanyardOptionIds = [161];

  const uncheckedValueE = {target: {checked: false}}
  const uncheckID = (id) => revoChange(uncheckedValueE, id);

  const handleChange = (e) => {
    setShowRevo((prevShowRevo) => !prevShowRevo);
    setActiveInnerStep(4);
    if (labelOnChange) {
      labelOnChange(e);
    }

    uncheckID(additionalWindowId);
    uncheckID(baseRevoOptionId);
    revoAdditionIds.forEach(id => uncheckID(id));
  };

  return (
    <div className="muiCheckbox">
      <MuiCheckbox
        checkboxes={showRevo ? selectedLabel : neutralLabel}
        boxLabel="RevoFit®"
        onChange={handleChange}
        defaultChecked={revoFitDefaultValue}
        value={value}
      />

      {showRevo && (
        <>
          <div style={{ marginTop: "-22px" }}>
            <MuiCheckbox
              checkboxes={checkBoxesOption.filter(opt => baseRevoOptionId === opt.id)}
              onChange={(e, id) => {
                  revoChange(e, id);
                  revoAdditionIds.forEach(id => uncheckID(id));
                }}
              defaultValue={revoOptionDefaultValue}
            />
          </div>

          {revoOptionDefaultValue[baseRevoOptionId] && (
            <div style={{ marginTop: "-22px" }}>
              <MuiCheckbox
                checkboxes={checkBoxesOption.filter(opt => revoAdditionIds.includes(opt.id))}
                onChange={revoChange}
                defaultValue={revoOptionDefaultValue}
              />
            </div>
          )}

          {revoOptionDefaultValue[additionalWindowId] && (
            <InputTextField
              label="Additional Window Quantity"
              variant="outlined"
              type="number"
              value={additionalWindowValue}
              required={additionalWindowRequired}
              onChange={additionalWindowChange}
            />
          )}
        </>
      )}
      <MuiCheckbox
        checkboxes={checkBoxesOption.filter(opt => lanyardOptionIds.includes(opt.id))}
        boxLabel="RevoLock® Lanyard"
        onChange={revoChange}
        defaultValue={revoOptionDefaultValue}
      />
    </div>
  );
};

export default Revofit;
